module.exports = __webpack_public_path__ + "static/media/why.8632b10c.jpg";